export default "__VITE_ASSET__Bwbw1dF5__"